if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    get cart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    revealInlineRestockForm() {
      const sectionElement = this.closest('[id^="MainProduct-"]');
      if (!sectionElement) return;

      const sectionId = sectionElement.dataset.section;
      if (!sectionId) return;

      const restockSignup = document.getElementById(`RestockSignup-${sectionId}`);
      if (!restockSignup) return;

      restockSignup.hidden = false;
      restockSignup.classList.remove('hidden');

      const emailInput = restockSignup.querySelector('input[name="contact[email]"]');
      if (emailInput) {
        emailInput.focus();
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (this.submitButton.classList.contains('js-restock-trigger')) {
        this.revealInlineRestockForm();
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// --- Restock "Notify Me" AJAX form submission ---
// Prevents the default page refresh when a customer submits the sold-out notify form.
// The form hidden fields (product handle, variant ID, etc.) are already populated
// by `updateRestockForm()` in global.js whenever the selected variant changes.

function initRestockForms() {
  document.querySelectorAll('.restock-form').forEach(attachRestockAjaxHandler);

  // Re-init when Shopify reloads a section in the theme editor
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.restock-form').forEach(attachRestockAjaxHandler);
  });
}

function attachRestockAjaxHandler(form) {
  // Guard: only bind once per form element to avoid duplicate listeners
  if (form.dataset.ajaxInitialized) return;
  form.dataset.ajaxInitialized = 'true';

  const submitButton = form.querySelector('[type="submit"]');

  // Redirect where the form response loads by pointing the form at a hidden
  // iframe. The submission itself (including Shopify's bot-protection token
  // injection) is left completely untouched — we never preventDefault() or
  // stopImmediatePropagation(). Shopify's scripts run, add their token, and
  // call form.submit() as normal; the 302 response just lands in the iframe
  // instead of navigating the main page.
  const iframeName = 'restock-frame-' + (form.id || Date.now());
  const iframe = document.createElement('iframe');
  iframe.name = iframeName;
  iframe.setAttribute('aria-hidden', 'true');
  iframe.tabIndex = -1;
  iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;overflow:hidden';

  // Insert the iframe immediately after the form so it shares the same
  // DOM parent and is easy to clean up alongside the form if needed.
  form.insertAdjacentElement('afterend', iframe);
  form.target = iframeName;

  let submissionPending = false;
  let submissionTimeoutId = null;

  // Track when the user actually submits so the first about:blank load
  // (which fires as soon as the iframe is attached) is ignored.
  form.addEventListener('submit', () => {
    const emailInput = form.querySelector('[name="contact[email]"]');
    if (!emailInput || !emailInput.value.trim()) return;

    submissionPending = true;
    submitButton.setAttribute('aria-disabled', 'true');

    // Safety net: if the iframe load event never fires (e.g. a network
    // failure or browser quirk), restore the form after 10 seconds.
    submissionTimeoutId = setTimeout(() => {
      if (!submissionPending) return;
      submissionPending = false;
      showRestockError(form, submitButton);
    }, 10_000);
  });

  iframe.addEventListener('load', () => {
    // Ignore the initial about:blank load that fires when the iframe is created.
    if (!submissionPending) return;

    clearTimeout(submissionTimeoutId);
    submissionPending = false;

    // Inspect the iframe document to distinguish a successful submission
    // (Shopify redirects to a thank-you state — no error markup present)
    // from a server validation failure (error elements are rendered).
    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      const hasServerError = iframeDoc.querySelector('.errors, [data-form-error]');

      if (hasServerError) {
        showRestockError(form, submitButton);
      } else {
        showRestockSuccess(form);
      }
    } catch {
      // A cross-origin exception here is extremely unlikely (same storefront
      // domain), but if it ever happens we optimistically show success because
      // the redirect itself means Shopify accepted the request.
      showRestockSuccess(form);
    }
  });
}

function showRestockSuccess(form) {
  const fieldsContainer = form.querySelector('.restock-form__fields');
  const successMessage = form.querySelector('.restock-form__success');
  const emailInput = form.querySelector('[name="contact[email]"]');

  // Clear the email so the form can't be re-submitted with stale data
  // if the user navigates back to this state via browser history.
  if (emailInput) emailInput.value = '';

  if (fieldsContainer) fieldsContainer.hidden = true;
  if (successMessage) successMessage.hidden = false;
}

function showRestockError(form, submitButton) {
  const errorMessage = form.querySelector('.restock-form__error');

  if (errorMessage) errorMessage.hidden = false;
  if (submitButton) submitButton.removeAttribute('aria-disabled');
}

initRestockForms();
